import { render } from "./CTextarea.vue?vue&type=template&id=413f7f54"
import script from "./CTextarea.vue?vue&type=script&lang=js"
export * from "./CTextarea.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__